import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { IvrTab } from '../ivr.const';

@Component({
  selector: 'switchboard-ivr-script',
  templateUrl: './script.component.html',
  styleUrls: ['../ivr.component.css', '../../switchboard.component.css'],
})
export class ScriptComponent implements OnInit {
  public is_detail = false;
  public item: any;
  constructor() {}

  ngOnInit() {}
  async openDetail(item) {
    this.item = item;
    this.is_detail = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/switchboard/ivr/script/script.component.ts